/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {TableVariantBasic, TableVariantComplex, TableRowScopeOnly, TableVariantFixed, TableStackedContainer, TableContainerEmptyHeaderFooter, TableClassHelpers, TableWithoutClasses, TableLongHeader, TableSticky, TableStickyMaxHeight, TableSizeMedium, TableSizeSmall, PaginationTable, TableAccordion, TablesInOneContainer} from 'Docs/uilib/components/table/Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    h3: "h3",
    p: "p",
    strong: "strong",
    code: "code"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Demos"
    }), "\n", _jsx(_components.h3, {
      children: "Basic table"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "NB:"
      }), " In this example, the sort buttons do react on your input. But will not change the table data."]
    }), "\n", _jsx(TableVariantBasic, {}), "\n", _jsx(_components.h3, {
      children: "Complex table"
    }), "\n", _jsxs(_components.p, {
      children: ["You can force a row to overwrite the automated odd/even counting by providing e.g. ", _jsx(_components.code, {
        children: "variant=\"even\""
      }), " to a ", _jsx(_components.code, {
        children: "<Tr />"
      }), ". You can use this in combination with ", _jsx(_components.code, {
        children: "rowSpan"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "NB:"
      }), " The table header in the first column needs to have ", _jsx(_components.code, {
        children: "scope=\"row\""
      }), "!"]
    }), "\n", _jsx(TableVariantComplex, {}), "\n", _jsx(_components.h3, {
      children: "Row scope headers only"
    }), "\n", _jsxs(_components.p, {
      children: ["This table has only ", _jsx(_components.code, {
        children: "scope=\"row\""
      }), " and ", _jsx(_components.code, {
        children: "scope=\"rowgroup\""
      }), " headers – without the default ", _jsx(_components.code, {
        children: "scope=\"col\""
      }), "."]
    }), "\n", _jsx(TableRowScopeOnly, {}), "\n", _jsx(_components.h3, {
      children: "Fixed table"
    }), "\n", _jsx(TableVariantFixed, {}), "\n", _jsx(_components.h3, {
      children: "Medium and small sized"
    }), "\n", _jsx(TableSizeMedium, {}), "\n", _jsxs(_components.p, {
      children: ["A ", _jsx(_components.code, {
        children: "small"
      }), " sized table is only for special circumstances, where a lot of data needs to be shown on the screen at the same time."]
    }), "\n", _jsx(TableSizeSmall, {}), "\n", _jsx(_components.h3, {
      children: "Table with accordion rows"
    }), "\n", _jsxs(_components.p, {
      children: ["The second example uses both a ", _jsx(_components.code, {
        children: "border"
      }), " and an ", _jsx(_components.code, {
        children: "outline"
      }), "."]
    }), "\n", _jsx(TableAccordion, {}), "\n", _jsx(_components.h3, {
      children: "Table with sticky header"
    }), "\n", _jsx(TableSticky, {}), "\n", _jsx(_components.h3, {
      children: "Table with a max height"
    }), "\n", _jsxs(_components.p, {
      children: ["A sticky table header with ", _jsx(_components.code, {
        children: "sticky=\"css-position\""
      }), " and ", _jsx(_components.code, {
        children: "max-height"
      }), " on the ", _jsx(_components.code, {
        children: "Table.ScrollView"
      }), "."]
    }), "\n", _jsx(TableStickyMaxHeight, {}), "\n", _jsx(_components.h3, {
      children: "Several tables in one container"
    }), "\n", _jsxs("details", {
      children: [_jsx("summary", {
        className: "dnb-p",
        children: _jsx(_components.p, {
          children: "Show how the import and syntax is structured."
        })
      }), _jsx(TablesInOneContainer, {})]
    }), "\n", _jsx(TableStackedContainer, {}), "\n", _jsxs(_components.p, {
      children: ["With no (empty) ", _jsx(_components.code, {
        children: "head"
      }), " and ", _jsx(_components.code, {
        children: "foot"
      }), " content."]
    }), "\n", _jsx(TableContainerEmptyHeaderFooter, {}), "\n", _jsx(_components.h3, {
      children: "Table with long header text (wrapping)"
    }), "\n", _jsx(TableLongHeader, {}), "\n", _jsx(_components.h3, {
      children: "Table with pagination"
    }), "\n", _jsx(PaginationTable, {}), "\n", _jsx(_components.h3, {
      children: "Example usage without and with classes"
    }), "\n", _jsx(TableWithoutClasses, {}), "\n", _jsx(TableClassHelpers, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
